import React, { useEffect, useState } from "react";
import { useFetch } from "hooks";
import { get } from "utils/api";
import { getApiErrorMessageCustomPathEnd } from "utils/misc";
import { useDispatch, useSelector } from "react-redux";

import { errorMessage } from "actions/message";

import TherapyDataList from "./therapy-data-list";
import { selectors } from "reducers";
import AddNewTherapyDataEntry from "./addNewTherapyDataEntry";

import { IoAndroidRefresh } from "react-icons/lib/io";

import PropTypes from "prop-types";
import { ToggleSwitch } from "components/ui";
import TherapyDataChangeLogs from "./therapt-data-change-logs";

const TherapyData = ({ patientId }) => {
  const user = useSelector(selectors.getUser);

  const isUserAllowedToCreateNewEntry = [
    "Administrator",
    "SaasCompanyAdmin",
    "OfficeAdministrator",
    "SaasOfficeAdministrator",
    "SaasSleepCoach"
  ].includes(user?.role);
  const userFullName = `${user?.first_name} ${user?.last_name}`;

  const dispatch = useDispatch();

  const [allTherapyData, setAllTherapyData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [logs, setLogs] = useState([]);

  const initialQuery = {
    filters: {}
  };

  const { fetchData: fetchTherapyData, isFetching } = useFetch({
    apiFn: () => get(`patients/${patientId}/therapy-data`),
    defaultValue: {},
    onError: error => {
      setFetching(false);
      dispatch(
        errorMessage(
          `Failed to fetch therapy data: ${getApiErrorMessageCustomPathEnd(
            error,
            "message"
          )}`
        )
      );
    },
    onSuccess: response => {
      setAllTherapyData(response);
      setFetching(false);
    }
  });

  const { fetchData: fetchTherapyDataLogs } = useFetch({
      apiFn: () => get(`patients/${patientId}/therapy-data-logs`),
      defaultValue: {},
      onError: error => {
        dispatch(
          errorMessage(
            `Failed to fetch therapy data logs: ${getApiErrorMessageCustomPathEnd(
              error,
              "message"
            )}`
          )
        );
      },
      onSuccess: response => {
        setFetching(false);
        setLogs(response);
      }
    });
  useEffect(() => {
    fetchTherapyData();
  }, []);

  useEffect(() => {
    setFetching(isFetching);
  }, [isFetching]);

  const [componentToRender, setComponentToRender] = useState("therapyDataList"); //therapyDataNewEntry
  const [therapyDataIdToEdit, setTherapyDataIdToEdit] = useState("");

  const closeNewEntryForm = () => {
    setComponentToRender("therapyDataList");
    setTherapyDataIdToEdit("");
    document.getElementById("manuallyRefreshTherapyData")?.click();
  };

  return (
    <div>
      <div style={{marginLeft:'20px', marginTop:'15px' }}>
        <ToggleSwitch 
        customLabel={"toggle-switch-label-important"}
          value={componentToRender == "changeLogs"}
          onChange={async () => {
            const newVal = componentToRender == "changeLogs" ? "therapyDataList" : "changeLogs";
            setComponentToRender(newVal)

            if(newVal == "changeLogs"){
              setLogs([]);
              setFetching(true);
              await fetchTherapyDataLogs();
            }
               
          }}
          title="View Change Logs"
          label="View Change Logs"
        />
      </div>
      {componentToRender == "therapyDataList" && (
        <div style={{ padding: "1rem" }}>
          {isUserAllowedToCreateNewEntry && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "1rem"
              }}
            >
              <span>
                <span
                  onClick={() => setComponentToRender("therapyDataNewEntry")}
                  disabled={isFetching}
                  style={{
                    color: "blue",
                    cursor: "pointer"
                  }}
                >
                  + New Entry
                </span>
              </span>
            </div>
          )}

          <TherapyDataList
            data={[allTherapyData]}
            isFetching={fetching}
            fetchData={fetchTherapyData}
            query={initialQuery}
            queryDispatcher={initialQuery}
            rows={allTherapyData}
            setComponentToRender={setComponentToRender}
            setTherapyIdToEdit={setTherapyDataIdToEdit}
            userRole={user?.role}
            patientId={patientId}
          />
        </div>
      )}
      {componentToRender == "therapyDataNewEntry" && (
        <AddNewTherapyDataEntry
          closeForm={closeNewEntryForm}
          userName={userFullName}
          patientId={patientId}
        />
      )}
      {componentToRender == "therapyDataEditEntry" && (
        <AddNewTherapyDataEntry
          therapyDataRecord={allTherapyData.find(
            x => x.Id === therapyDataIdToEdit
          )}
          closeForm={closeNewEntryForm}
          userName={userFullName}
          patientId={patientId}
        />
      )}
      {componentToRender == "changeLogs"  && (
        <TherapyDataChangeLogs rows={logs} query={initialQuery}
            queryDispatcher={initialQuery} isFetching={fetching} />
      )}
      {componentToRender != "changeLogs" &&<div
        id="manuallyRefreshTherapyData"
        onClick={() => fetchTherapyData()}
        style={{ width: "40px" }}
      >
        <IoAndroidRefresh
          color="#4281a6"
          size={20}
          style={{ margin: "10px" }}
        />
      </div>}
    </div>
  );
};

export default TherapyData;

TherapyData.propTypes = {
  patientId: PropTypes.string
};
